import { Component, OnInit, Inject } from '@angular/core';
import { ApiServices } from '../shared/api.services';
import { PagerService } from '../services/pager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface RequestsPopup {
  username: string;
  requests: [{}];
}

@Component({
  selector: 'app-requested-reports',
  templateUrl: './requested-reports.component.html',
  styleUrls: ['./requested-reports.component.css']
})
export class RequestedReportsComponent implements OnInit {

  title = "Requested Reports";
  requested_users: any;
  requested_users_data = {};
  requested_user_id: string;
  requested_user_status: string = "";
  requested_user_list: any;
  requested_user_count: number;
  successMsg: string;
  errorMsg: string;
  modelError = '';

  isAlert = false;
  alertClass = '';
  alertMsg = '';

  isLoaderShow = false;

  constructor(public apiServices: ApiServices,
    private pagerService: PagerService,
    public dialog: MatDialog) { }

  base_url: string;
  // pager object
  pager: any = {};
  // paged items
  pagedItems: any[];
  pagedItemsLength: number;
  // Set number of records per page
  limit: number = 10;
  // Pagination elements
  pageSize: number = 10;
  offset: number = 0;
  skip: number = 0;

  filters: any = {};
  is_admin_reporting = "true";


  ngOnInit() {
    this.base_url = this.apiServices.base_url;
    this.isLoaderShow = false;
    this.setPage(1, this.pageSize);
  }

  changeUserLimit(event: any) {
    this.pageSize = parseInt(event.target.value);
    this.setPage(1, this.pageSize);
  }

  getKeys(obj) {
    return Object.keys(obj)
  }

  getRequestReports(filters: any) {
    return new Promise((resolve, reject) => {
      this.apiServices.getRequestReports(filters).subscribe(requested_users => {
        this.isLoaderShow = true;
        resolve(requested_users);
      })
    })
  }

  setPage(page: number, pageCount: number) {
    this.isLoaderShow = false;
    // setting limit and skip values
    if (page > 1) {
      this.filters['limit'] = pageCount;
      this.filters['skip'] = (page - 1) * this.pager.pageSize;
    } else {
      this.filters['limit'] = pageCount;
      this.filters['skip'] = this.skip;
    }
    // set skip value when Id is present
    if (this.requested_user_status == "false") {
      this.filters['skip'] = (this.pager.currentPage - 1) * this.pager.pageSize;
    }
    /* if (this.filters._id != "" && this.filters._id != null) {
      this.filters['skip'] = (this.pager.currentPage - 1) * this.pager.pageSize;
      delete this.filters._id;
    } */

    // set filters
    this.filters['is_admin_reporting'] = this.is_admin_reporting;

    this.getRequestReports(this.filters).then(userdata => {
      this.requested_user_list = userdata;
      this.isLoaderShow = true;
      return;
    })
      .then(() => {
        // total count
        this.requested_user_count = this.requested_user_list['total'];
        // users list
        this.requested_users = this.requested_user_list['data'];
        // get pager object from service
        this.pager = this.pagerService.getPager(this.requested_user_count, page, pageCount);

        // get current page of items
        // this.pagedItems = this.users.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.pagedItems = this.requested_users;
        this.pagedItemsLength = this.pagedItems.length;
        // deleting id and search key from filters
        delete this.filters.limit; delete this.filters.skip;
      })
  }

  unBlockUser(user_id: string) {
    var con_string = document.getElementById("unblock").innerHTML;
    if (confirm(con_string)) {
      this.requested_user_status = "false";
      let params = {
        userId: user_id,
        disable: this.requested_user_status
      }
      // Un Block reported user
      this.apiServices.changeUserStatus(params).subscribe(res => {
        if (res['status'] == "success") {
          // status updated
        } else {
          // status not updated
        }
        this.setPage(1, this.pageSize);
      });
    }
  }

  openRequestDialog(username: string,requests: [{}]): void {
    const dialogRef = this.dialog.open(RequestsOverView, {
      width: '750px',
      data: { username: username, requests: requests }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}

@Component({
  selector: 'user-requests',
  templateUrl: 'user-requests-popup.html',
})
export class RequestsOverView {

  constructor(
    public dialogRef: MatDialogRef<RequestsOverView>,
    @Inject(MAT_DIALOG_DATA) public data: RequestsPopup) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
